export default {
	computed: {
		documentTitle() {
			return "";
		},
	},
	methods: {
		async trySetDocumentTitle() {
			const { documentTitle, } = this;
			if ( documentTitle ) {
				await this.$nextTick();
				window.document.title = documentTitle;
			}
		},
	},
	watch: {
		documentTitle() {
			this.trySetDocumentTitle();
		},
		$route() {
			this.trySetDocumentTitle();
		},
	},
	mounted() {
		this.trySetDocumentTitle();
	},
};
